import React from 'react';
import { Button, Box } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';


const Login = () => {
    const handleGithubLogin = () => {
        window.location.href = '/auth/github';
    };

    return (
        <Box sx={{ maxWidth: '400px', margin: 'auto' }}>
            <Button
                variant="contained"
                color="inherit"
                startIcon={<GitHubIcon />}
                fullWidth
                onClick={handleGithubLogin}
                sx={{
                    backgroundColor: '#24292e',
                    color: '#ffffff',
                    '&:hover': {
                        backgroundColor: '#1b1f23',
                    },
                    textTransform: 'none',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    padding: '10px',
                    marginBottom: '20px',
                }}
            >
                Continue with GitHub
            </Button>
        </Box>
    );
};

export default Login;